module.exports = __webpack_public_path__ + "static/media/brennemoen.346d82e9.jpg";